/**
 * Le Nouveau Panier (screens/Checkout/v2) est le panier de la nouvelle
 * interface (src/v2, docs/ux-v2/SPEC.md CK1) et n'existe que par elle :
 * Frontend.php injecte `checkoutConfig.enabled = UxV2::isActive()`. Dans
 * l'interface actuelle, l'ancien récapitulatif de commande est rendu tel quel.
 */
export function isNewCheckoutEnabled(): boolean {
  return typeof mondayMindbody !== 'undefined' && mondayMindbody?.checkoutConfig?.enabled === true;
}
